<div #introView>
  <eid-intro-one-mobile *ngIf="activeStep === 1" (step)="stepSelected($event)"></eid-intro-one-mobile>
  <eid-intro-two-mobile *ngIf="activeStep === 2" (step)="stepSelected($event)"></eid-intro-two-mobile>
  <eid-intro-three-mobile *ngIf="activeStep === 3" (step)="stepSelected($event)"></eid-intro-three-mobile>
  <eid-intro-four-mobile *ngIf="activeStep === 4" (step)="stepSelected($event)"></eid-intro-four-mobile>
  <eid-intro-five-mobile *ngIf="activeStep === 5" (step)="stepSelected($event)"></eid-intro-five-mobile>
</div>
